export const Endpoint = "https://veriq-api.readytopay.net";
export const LocationId = "652725277b0326a323666c5b";
export const LSIdentityKey = "veriq-identity";
export const LSRegistrationKey = "veriq-registration";
